import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ISlotList } from '../../../Pages/Slot/ISlot';

export const AddFixtureSlicer = createSlice({
  name: 'AddFixture',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<ISlotList>,
  reducers: {
    addFixture: (state, _) => {
      state.isLoading = true;
    },
    successAddFixture: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureAddFixture: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearAddFixtureState: (state) => {
      state.data = {};
    },
  },
});

export const {
  addFixture,
  failureAddFixture,
  successAddFixture,
  clearAddFixtureState,
} = AddFixtureSlicer.actions;

export default AddFixtureSlicer.reducer;
